import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './styles.css'
import Modal from 'component/Modal/index';

const ViewModal = ({
  translate,
  toggleView,
  toggleEdit,
  isOpen,
  parameter,
}) => {
  const [copiedRow, setCopiedRow] = useState(null);
  
  if (!isOpen) return null;

  const handleConfirm = () => {
    console.log("current item",parameter)
    toggleView(false); 
    toggleEdit(true, parameter);
  };

  const handleCopy = (valueToCopy) => {
    navigator.clipboard.writeText(valueToCopy).then(() => {
      setCopiedRow(true);

      setTimeout(() => setCopiedRow(null), 2000); 
    });
  };

  return (
    <Modal
      title={"Visualizar parâmetro"} 
      confirmButtonText={translate('edit_button_label')} 
      cancelButtonText={translate('cancel_button')} 
      isOpen={isOpen}
      size="md"
      onCloseModal={() => toggleView(false)}
      onConfirm={handleConfirm} 
    >
      <>
        {parameter ? (
          <>
            <div className='container-parameter'>
              <div className='parameter-item'>
                <div className="w-100 margin-top color-default">{translate('parameter')}</div>
                <div className="w-100 sm-margin-top">{parameter.nuParameter}<span className='margin-hyphen'>-</span>{parameter.dsKey}</div>  
              </div>
              
              <div>
                <div className="w-100 margin-top color-default noBreakWord">{translate('parameters.registered-idBranch')}</div>
                <div className="w-100 sm-margin-top">{parameter.idBranch === "0" ? "Todas" : parameter.idBranch}</div>
              </div>
              
            </div>
           
            <div className="w-100 margin-top color-default">{translate('parameters.dsDocument')}</div>
            <div className="w-100 sm-margin-top">{parameter.dsParameter}</div>

            <div className="w-100 margin-top color-default">{`${translate('parameters.dsValue')} - String`}
              <span
                className='copyValue margin-left-15'
                onClick={() => handleCopy(parameter.dsValue)}
                style={{ cursor: 'pointer', color: copiedRow ? '#158110' : '#41A017' }}
              >
                {copiedRow ? 'Copiado!' : 'Copiar valor'}
              </span> 
            </div>
            <div className="w-100 sm-margin-top">{parameter.dsValue}</div>
           
            <div className="w-100 margin-top color-default">{translate('parameter-observations')}</div>
            <div className="w-100 sm-margin-top"> {parameter.dsDocument ? parameter.dsDocument : '-'}</div>
          </>
        ) : (
          <div>{translate('parameter-list.not-found')}</div> 
        )}
      </>
    </Modal>
  );
};

ViewModal.propTypes = {
  translate: PropTypes.func.isRequired,
  toggleView: PropTypes.func.isRequired,
  toggleEdit: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  parameter: PropTypes.object,
};

export default ViewModal;
export { ViewModal };
